import { Component } from '@angular/core';
import {RouterLink} from "@angular/router";
import {SubscribeComponent} from "../../common/subscribe/subscribe.component";

@Component({
  selector: 'app-mitgliedschaft',
  standalone: true,
    imports: [
        RouterLink,
        SubscribeComponent
    ],
  templateUrl: './mitgliedschaft.component.html',
  styleUrl: './mitgliedschaft.component.scss'
})
export class MitgliedschaftComponent {

}
